(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import moment from 'moment';
import { ProfileManager } from '@kailona/core';
export default function mapToFHIR(activitiesData) {
  var fhirPatientId = ProfileManager.activePatientId;

  if (!fhirPatientId) {
    throw new Error('Invalid patient id');
  }

  var datePeriod = activitiesData.datePeriod,
      steps = activitiesData.steps,
      distance = activitiesData.distance,
      calories = activitiesData.calories;

  if (!datePeriod || !steps && !distance && !calories) {
    return null;
  }

  var observation = {
    resourceType: 'Observation',
    status: 'final',
    category: [{
      coding: [{
        system: 'http://hl7.org/fhir/ValueSet/observation-category',
        code: 'activity',
        display: 'Activity'
      }]
    }],
    code: {
      coding: [{
        system: 'http://loinc.org',
        code: '62812-3',
        display: 'Physical activity and physical fitness'
      }],
      text: 'Activity'
    },
    subject: {
      reference: "Patient/".concat(fhirPatientId)
    },
    effectivePeriod: {
      start: moment(datePeriod.start).utc().toISOString(),
      end: moment(datePeriod.end).utc().toISOString()
    },
    component: []
  };

  if (steps) {
    observation.component.push({
      code: {
        coding: [{
          system: 'http://loinc.org',
          code: '55423-8',
          display: 'Number of steps in unspecified time Pedometer'
        }],
        text: 'Steps'
      },
      valueQuantity: {
        value: parseInt(steps, 10)
      }
    });
  }

  if (distance) {
    observation.component.push({
      code: {
        coding: [{
          system: 'http://loinc.org',
          code: '55430-3',
          display: 'Walking distance'
        }],
        text: 'Distance'
      },
      valueQuantity: {
        value: parseFloat(distance),
        unit: 'm',
        system: 'http://unitsofmeasure.org',
        code: 'm'
      }
    });
  }

  if (calories) {
    observation.component.push({
      code: {
        coding: [{
          system: 'http://loinc.org',
          code: '55421-2',
          display: 'Calories burned'
        }],
        text: 'Calories'
      },
      valueQuantity: {
        value: parseFloat(calories),
        unit: 'cal',
        system: 'http://unitsofmeasure.org',
        code: 'cal'
      }
    });
  }

  if (activitiesData.id) {
    observation.id = activitiesData.id;
  }

  return observation;
}
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(mapToFHIR, "mapToFHIR", "/home/runner/html/nextcloud/apps/ehr/js/plugins/activities/src/mappers/mapToFHIR.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();